import { apiClient } from '../apiClient';

export const PATHS = {
  STREAM_USER_AUTH: '/api/v1/stream-user-auth/',
} as const;

// The wire row from /api/v1/stream-user-auth/ (camelized by the humps response
// interceptor: stream_auth_token → streamAuthToken).
type StreamUserAuthRow = { streamAuthToken?: string };

type StreamUserAuthResponse = StreamUserAuthRow[] | StreamUserAuthRow;

// Mirrors Sparta's getStreamAuthToken: GET /api/v1/stream-user-auth/. Returns
// the current user's Stream Chat auth token (used to connect the headless
// stream-chat client), or null if the endpoint returns nothing usable. The auth
// header is attached automatically by the apiClient request interceptor.
export async function fetchStreamAuthToken(signal?: AbortSignal): Promise<string | null> {
  const res = await apiClient.get<StreamUserAuthResponse>(PATHS.STREAM_USER_AUTH, { signal });
  // Sparta types the response as an array `[{ streamAuthToken }]`; tolerate a
  // bare object too.
  const row = Array.isArray(res.data) ? res.data[0] : res.data;
  return row?.streamAuthToken ?? null;
}
